import { render } from "./LoginModelNew.vue?vue&type=template&id=4de6449a&scoped=true"
import script from "./LoginModelNew.vue?vue&type=script&lang=js"
export * from "./LoginModelNew.vue?vue&type=script&lang=js"

import "./LoginModelNew.vue?vue&type=style&index=0&id=4de6449a&scoped=true&lang=scss"
import "./LoginModelNew.vue?vue&type=style&index=1&id=4de6449a&lang=scss"

import exportComponent from "/codebuild/output/src3487515193/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4de6449a"]])

export default __exports__